export default __webpack_public_path__ + "static/media/cloud.d650724c.svg";